import { gql } from "@apollo/client";

export const KeyDateFragment = gql`
  fragment KeyDateFragment on KeyDate {
    documentId
    title
    description
    dateType
    startDate
    endDate
    relativeRule
    sectionType {
      documentId
      value
      label
    }
    topicLabel {
      documentId
      value
      label
    }
    month
    requiresReview
    isDeleted
    originalText
    source
    academicYear
    bookYourPlaceUrl
    learnMoreUrl
    schools {
      documentId
      name
    }
  }
`;

export const QUERY_KEY_DATES = gql`
  query KeyDates($limit: Int, $startDate: Date, $schoolContextDocumentId: ID!) {
    keyDates: filteredKeyDates(
      page: 1
      pageSize: $limit
      startDate: $startDate
      schoolContextDocumentId: $schoolContextDocumentId
    ) {
      nodes {
        ...KeyDateFragment
      }
      pageInfo {
        page
        pageCount
        total
        pageSize
      }
    }
    keyDatePage {
      title
      calendarTitle
      description
      searchPlaceholder
      previousMonthButton
      nextMonthButton
      noKeyDatesFoundText
      bookYourPlaceLabel
      learnMoreLabel
      deadlineLabel
      addToCalendarLabel
      calendarAppleLabel
      calendarGoogleLabel
      calendarOutlookLabel
      tagTrustAction
      tagReminder
      tagAwarenessDay
      tagEvent
      tagPayment
      tagAnnouncement
    }
  }
  ${KeyDateFragment}
`;

export const QUERY_KEY_DATES_LIST = gql`
  query KeyDatesList(
    $page: Int!
    $pageSize: Int
    $startDate: Date
    $endDate: Date
    $sectionType: ID
    $title: String
    $schoolContextDocumentId: ID!
  ) {
    keyDates: filteredKeyDates(
      page: $page
      pageSize: $pageSize
      startDate: $startDate
      endDate: $endDate
      sectionType: $sectionType
      title: $title
      schoolContextDocumentId: $schoolContextDocumentId
    ) {
      nodes {
        ...KeyDateFragment
      }
      pageInfo {
        page
        pageCount
        total
        pageSize
      }
    }
    keyDatePage {
      title
      calendarTitle
      description
      searchPlaceholder
      previousMonthButton
      nextMonthButton
      noKeyDatesFoundText
      bookYourPlaceLabel
      learnMoreLabel
      deadlineLabel
      addToCalendarLabel
      calendarAppleLabel
      calendarGoogleLabel
      calendarOutlookLabel
      tagTrustAction
      tagReminder
      tagAwarenessDay
      tagEvent
      tagPayment
      tagAnnouncement
    }
  }
  ${KeyDateFragment}
`;

export const QUERY_SECTION_TYPES = gql`
  query SectionTypes {
    sectionTypes {
      documentId
      value
      label
    }
  }
`;

export const QUERY_TOPIC_LABELS = gql`
  query TopicLabels {
    topicLabels {
      documentId
      value
      label
    }
  }
`;
